/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";
import { parse, format, isValid } from "date-fns";

import DateFnsUtils from '@date-io/date-fns'; 
import { zonedTimeToUtc } from 'date-fns-tz'
import {
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'

class FlexDatePicker extends Component {
  state = {
    dateAsString: this.props.instance.value.text || null,
    format: null,
    selectedDate: null,
    value: this.props.instance.value.text || null
  };

  setDateTime = (value) => {
    console.log("value")
    console.log(value)
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    console.log("Current Time Zone : ", timezone )

    if( value !== null ){
      this.props.update_value(this.props.instance.id, 'text', zonedTimeToUtc(format(new Date(value),'yyyy-MM-dd HH:mm:ss'), timezone).toISOString())
    } else {
      this.props.update_value(this.props.instance.id, 'text', null)
    }
    
  }

  convertToISOString = (date_string) => {
    let date = new Date(date_string)
    var tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function(num) {
        var norm = Math.floor(Math.abs(num));
        return (norm < 10 ? '0' : '') + norm;
    };

    return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds()) +
            dif + pad(tzo / 60) +
            ':' + pad(tzo % 60);
  }

  render() {
    console.log("date picker props")
    console.log(this.props)
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DateTimePicker
            fullWidth
            label = {this.props.instance.name}
            //clearable = { this.state.recursive === true ? false : true}
            clearable = "true"
            value={this.props.instance.value.text}
            onChange={(value) => {
              this.setDateTime(value)
            }}
            helperText="Choose Date and Time"
            format="yyyy/MM/dd HH:mm"
        />
      </MuiPickersUtilsProvider>
    );
  }
}
export default FlexDatePicker;
